import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { UtilService } from '../../_shared/services/util.service';

import { Facility } from '../shared/facility.model';
import { FacilityService } from '../shared/facility.service';

@Component({
  selector: 'app-facility-list',
  templateUrl: './facility-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class FacilityListComponent implements OnInit, OnDestroy {
  constructor(
    private facilityService: FacilityService,
    private abilityService: AbilityService,
    private dataService: DataService,
    public utilService: UtilService
  ) {}

  @Input() facilities: Facility[];
  @Input() meta; // : []
  @Input() loadingFacilities: boolean;
  @Input() defaultLanguage;

  @Output() private selectedFacility = new EventEmitter<{ facility: Facility; mode: string }>();
  // @Output() private selectedFacility = new EventEmitter<any>();

  permissions = {
    canShow: this.abilityService.can('show_facility_accountadmin'),
    canUpdate: this.abilityService.can('update_facility_accountadmin'),
    canDestroy: this.abilityService.can('destroy_facility_accountadmin'),
  };

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  filterCriteria = this.facilityService.getFilterCriteria();

  masterCheckboxSelected = false;
  showListActions = false;
  totalItemsSelected = 0;

  private $subs: Subscription;

  ngOnInit() {
    this.$subs = this.utilService.getCheckboxsSubjectValue().subscribe((data) => {
      this.showListActions = data.showListActions;
      this.totalItemsSelected = data.totalItemsSelected;
      this.masterCheckboxSelected = data.masterCheckboxSelected;
    });
  }

  ngOnDestroy() {
    if (this.$subs) {
      this.$subs.unsubscribe();
    }
  }

  reloadFacilities() {
    this.filterCriteria = this.facilityService.getFilterCriteria();

    this.getFacilities();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterFacilities(field, value);
  }

  filterFacilities(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getFacilities();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getFacilities();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getFacilities();
  }

  selectFacility(facility: Facility, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedFacility.emit({ facility, mode });
  }

  // Referenced from app-list-actions
  onUpdatedItems(option) {
    let successCallback = () => {
      this.getFacilities();
    };

    this.dataService.changeItemsStatus('facilities', this.facilities, option, successCallback);
  }

  // Referenced from app-list-actions
  onDeletedItems() {
    let successCallback = () => {
      this.getFacilities();
    };

    this.dataService.deleteItems('facilities', this.facilities, successCallback);
  }

  changeFacilityStatus(facility: Facility) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(facility.id);
    };

    this.dataService.changeItemStatus('facilities', facility, successCallback, {});
  }

  deleteFacility(facility: Facility) {
    let successCallback = () => {
      this.getFacilities();
    };

    const params = {
      title: 'DELETE_FACILITY',
      message: 'SURE_TO_DELETE_FACILITY',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'DELETED_FACILITY',
    };

    this.dataService.deleteItem('facilities', facility, successCallback, params);
  }

  private getFacilities() {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingFacilities = true;
    this.facilityService.getFacilities(this.filterCriteria).subscribe((response) => {
      this.facilities = response.data;
      this.meta = response.meta;

      this.loadingFacilities = false;
    });
  }
}
